var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Catalog } from '../../Settings/SettingsStore';
import { inject, observer } from 'mobx-react';
import { CatalogViewType } from '../../UI/Store';
import OperationLinesList from './OperationLinesList';
import { View } from '../../../elements';
import theme, { hairline } from '../../../Theme';
import Touchable from '../../../elements/Touchable';
import { T } from '../../../helpers/i18n';
import { Text } from '../../../elements';
import NavBar from '../../../components/NavBar';
import CollaboratorStretchesList from '../../CollaboratorStretches/container/CollaboratorStretchesList';
import { SearchInput } from '../../../components';
let OperationLinesContainer = class OperationLinesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            showBusinessUnits: false,
            selected: this.props.store.settingsStore.catalogSelected || Catalog.Stretches,
            showFamilies: false
        };
        this.handleSearch = (searchTerm) => {
            this.setState({ searchTerm });
        };
        this.toggleBusinessUnits = () => {
            this.setState((state) => ({
                showBusinessUnits: !state.showBusinessUnits,
            }));
        };
        this.toggleFamilies = () => {
            // this.setState({showFamilies: !this.state.showFamilies})
            this.setState((state) => ({ showFamilies: !state.showFamilies }));
        };
        this.state = {
            searchTerm: '',
            showBusinessUnits: false,
            selected: this.props.store.settingsStore.catalogSelected || Catalog.Stretches,
            showFamilies: false
        };
        // console.log('this.state', this.state)
    }
    componentDidMount() {
        this.props.store.UI.setViewType(CatalogViewType.Cell);
        this.props.store.businessUnits.read();
    }
    handleCatalogSelected(value) {
        this.props.store.settingsStore.setCatalogSelected(value);
        this.setState({ selected: value });
    }
    render() {
        const { searchTerm, showBusinessUnits, selected, showFamilies } = this.state;
        let paraRender;
        if (selected === Catalog.Stretches) {
            paraRender = React.createElement(OperationLinesList, { searchTerm: searchTerm });
        }
        else if (selected === Catalog.CollaboratorStretches) {
            paraRender = React.createElement(CollaboratorStretchesList, { searchTerm: searchTerm });
        }
        return (React.createElement(View, { center: true, flex: true },
            React.createElement(View, { style: Object.assign({}, hairline.bottom) },
                React.createElement(Touchable, { style: styleTouchable, onClick: () => { this.handleCatalogSelected(Catalog.Stretches); } },
                    React.createElement(Text, { style: { color: selected === Catalog.Stretches ? theme.color.primary : undefined }, center: true }, T('services'))),
                React.createElement(Touchable, { style: styleTouchable, onClick: () => { this.handleCatalogSelected(Catalog.CollaboratorStretches); } },
                    React.createElement(Text, { style: { color: selected === Catalog.CollaboratorStretches ? theme.color.primary : undefined }, center: true }, T('collaboratorStretches')))),
            selected === Catalog.Articles && React.createElement(NavBar
            /*left={
              <Search
                onChangeText={this.handleSearch}
                expandable
                style={{
                  flex: 1,
                  paddingHorizontal: theme.size.horizontal
                }}
              />
            }
            center={false}*/
            /*right={
              <CountUp to={total} money big>
                0
              </CountUp>
            }*/
            , null),
            React.createElement(View, { row: true, center: true, style: Object.assign(Object.assign({}, hairline.bottom), { alignItems: 'center', justifyContent: 'center', width: '100%' }) }, selected === Catalog.Stretches && (React.createElement(SearchInput, { onChange: this.handleSearch }))),
            paraRender));
    }
};
OperationLinesContainer = __decorate([
    inject('store'),
    observer
], OperationLinesContainer);
export const styleTouchable = {
    flex: 1,
    marginLeft: 5,
    marginRight: 5,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center'
};
export const ViewType = {
    Cell: 'cell',
    Row: 'row',
    line: 'line'
};
export default OperationLinesContainer;



//////////////////
// WEBPACK FOOTER
// ./src/modules/OperationLines/container/OperationLinesContainer.tsx
// module id = 240
// module chunks = 0